import { parse } from "node-html-parser";
import styled from "styled-components";
import { WPBlock } from "../../../blocks/model/WPBlocks";
import { device } from "../../../styles/device";
import PostBlockManager from "./PostBlockManager";

const PostBodyWrapper = styled.div`
  font-size: 19px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: -0.01em;
  overflow-wrap: break-word;

  h2 {
    font-size: 28px;
    line-height: 35px;
    font-weight: 700;

    @media ${device.tablet} {
      font-size: 32px;
      line-height: 40px;
      font-weight: 700;
    }
  }

  h3 {
    font-size: 28px;
    line-height: 36px;
    font-weight: 700;
  }

  .wp-block-pullquote {
    border-top: 1px solid #d0d0d0;
    border-bottom: 1px solid #d0d0d0;
  }

  blockquote {
    text-align: center;
    margin-left: 0;
    margin-right: 0;
  }

  p,
  ul,
  ol,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    @media ${device.tablet} {
      width: 576px;
    }
    @media ${device.laptop} {
      width: 653px;
    }
  }

  p {
    margin-bottom: 27px;
    margin-top: 0;
  }

  iframe {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
    margin-bottom: 32px;
    margin-top: 5px;
    border-radius: 8px;

    @media ${device.tablet} {
      margin-bottom: 64px;
      margin-top: 37px;
    }
  }

  figure {
    margin-block: 0;
    margin-inline: 0;
    margin-top: 44px;
    margin-bottom: 44px;
    width: 100%;
    @media ${device.tablet} {
      width: 576px;
    }
    @media ${device.laptop} {
      width: 653px;
    }
    margin-left: auto;
    margin-right: auto;

    figcaption {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #6e6e73;
      margin-top: 8px;
      font-size: 12px;
      line-height: 1.33337;
      font-weight: 600;
      text-align: center;
    }

    img {
      width: 100%;
      height: auto;
      object-fit: cover;
      border-radius: 16px;
    }
  }

  .size-full {
    width: 100%;
    @media ${device.tablet} {
      width: 100%;
    }
    @media ${device.laptop} {
      width: 100%;
    }
  }

  a {
    color: ${(props) => props.theme.colors.buttonPrimary};
  }

  .wp-block-gallery {
    width: 100%;
    display: grid;
    flex-wrap: wrap;
    grid-template-columns: minmax(0, 1fr);
    column-gap: 16px;
    row-gap: 16px;
    max-width: 1080px;
    list-style: none;
    padding: 0;

    @media ${device.tablet} {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }
    @media ${device.laptop} {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    }
    .blocks-gallery-item {
      width: 100%;
    }
    figure {
      margin: 0;
      width: 100%;
    }
  }
`;

interface PostBodyProps {
  content: any;
  blocks: any[];
  postEventBanner: any;
}

export default function PostBody({
  content,
  blocks: blocks,
  postEventBanner,
}: PostBodyProps) {
  let part1;
  let part2;
  const hasMultipleBlocks = blocks.length > 1;

  if (hasMultipleBlocks) {
    const position = Math.round(blocks.length - 1) / 2;
    const eventBannerBlock: WPBlock = {
      name: "custom/eventbanner",
      order: position,
    };
    if (
      blocks.filter((block) => block.name === "custom/eventbanner").length < 1
    ) {
      blocks.splice(position, 0, eventBannerBlock);
    }
  } else {
    const root = parse(content);
    part1 = root.childNodes.slice(
      0,
      Math.round(root.childNodes.length - 1) / 2
    );
    part2 = root.childNodes.slice(
      Math.round(root.childNodes.length - 1) / 2,
      root.childNodes.length - 1
    );
  }

  return (
    <PostBodyWrapper>
      {hasMultipleBlocks ? (
        <PostBlockManager blocks={blocks} postEventBanner={postEventBanner} />
      ) : (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: part1.join(""),
            }}
          />
          {postEventBanner}
          <div
            dangerouslySetInnerHTML={{
              __html: part2.join(""),
            }}
          />
        </>
      )}
    </PostBodyWrapper>
  );
}
